import src from "IMAGE";
export default { src, width: 153, height: 36, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42hXKuwkAIRREUaP3K2sb2SoWNhUxMRAEMbJYr8HA4TIpIqq7F1V9ReTBnbbZMLOcQGHtnggfXrjiH88DLj0Jvx/DOQgAAAAASUVORK5CYII="};
